export const projects = [
  {
    title: "Mixyr Music Bot",
    subtitle: "Python and Discord API",
    description:
      "This Discord bot is developed using Discord.py and Python, featuring the implementation of slash commands to facilitate music playback for server members. It supports seamless integration with Discord's API, allowing users to play, pause, skip, and manage music tracks directly within their server. The bot is designed to handle multiple concurrent requests efficiently, ensuring a smooth and reliable music experience for all users. Its robust architecture ensures compatibility with various server setups and user needs, making it a versatile addition to any Discord community.",
    image: "./project-1.gif",
    link: "https://github.com/CDay98/Mixyr",
    target: "_blank",
    buttonName: "",
  },
  {
    title: "CDay's Bot Hub",
    subtitle: "Html, CSS, and Javascript",
    description:
      "This website, crafted with HTML, CSS, and JavaScript, serves as a comprehensive showcase for custom Discord bot development. Designed with a user-friendly interface and responsive design, it ensures an optimal browsing experience across all devices. The site features a sleek, modern layout that highlights my portfolio. Interactive elements and smooth animations enhance user engagement. While this project is not currently hosted feel free to click this square to view the repository.",
    image: "./project-2.gif",
    link: "https://github.com/CDay98/MusicBot-Web",
    target: "_blank",
    buttonName: "",
  },
  {
    title: "Application Address Verification",
    subtitle: "JavaScript, JQuery, and REST API",
    description:
      "*Proprietary, Not Viewable* I developed an address autocomplete system specifically for college admissions applications, utilizing JavaScript and jQuery to interface with the Melissa API. This system enhances user experience by providing real-time address suggestions as applicants type, ensuring accurate and complete address information. By integrating the Melissa API, the system retrieves and auto-fills address data swiftly, reducing input errors and improving the overall efficiency of the application process.",
    image: "./project-3.gif",
    // eslint-disable-next-line
    link: "javascript:void(0)",
    target: "",
    buttonName: "No Repo Available",
  },
  {
    title: "Car Crew",
    subtitle: "MERN Stack", 
    description:
      "This Car Crew web application is built using the MERN stack (MongoDB, Express, React, and Node.js) with integration of Clerk for user authentication, Stripe for payment processing, and UploadThing for file uploads. The platform allows event organizers to host and manage car meets. Users can seamlessly sign up, view event details, and pay for events securely. Its efficient architecture supports scalable features, ensuring smooth handling of user data, media uploads, and payments, making it a comprehensive solution for automotive communities looking to connect through shared events and experiences. Find the repo on my github!",
    image: "./project-4.gif",
    link: "https://car-crew.vercel.app/events/66d3382a7a066136f9f1628f",
    target: "_blank",
    buttonName: "View Website",
  },
];

export const testimonials = [
  {
    quote:
      "...",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "...",
    company: "...",
  },
  {
    quote:
      "...",
    image: "https://randomuser.me/api/portraits/men/4.jpg",
    name: "...",
    company: "...",
  },
];

export const skills = [
  "Python",
  "Javascript",
  "React / React Native",
  "SQL",
  "APIs",
  "Oracle Database",
];



// WEBPACK FOOTER //
// ./src/data.js